export default __webpack_public_path__ + "assets/FormsAccountNotEnabled.a6e3c2ba89.png";